import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import Navbar from './header/Navbar';
import Hero from './Hero';
import Snackbar, { openSnackbar } from './utils/Snackbar';
import axios from '../axios/axios';
import CircularProgress from '@material-ui/core/CircularProgress';

const style = theme => ({
    heroContent: {
        width: '60%',
        margin: '0 auto',
        padding: '20px 0',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    heroHeader: {
        fontSize: '50px',
        fontWeight: '400',
        color: '#FFFFFF',
        textAlign: 'center',
        margin: '120px 0 120px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px',
            margin: '60px 0 60px 0',
        },
        '&::after': {
            display: 'block',
            width: '1.5em',
            height: '3px',
            background: '#51e3d4',
            content: '" "',
            margin: '7px auto',
            borderRadius: '2px'
        }
    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '20px 0',
        textAlign: 'center',
    },
    textHeading: {
        margin: '25px 0',
        fontSize: '30px',
        fontWeight: '700',
        fontFamily: "Playfair Display,serif",
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    blogCard: {
        cursor: 'pointer'
    },
    blogImage: {
        width: '100%',
        height: '210px',
        objectFit: 'contain'
    },
    blogTitle: {
        margin: '10px 0',
        fontSize: '25px',
        fontFamily: "Playfair Display,serif",
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px'
        }
    },
    blogDate: {
        margin: '5px 0',
        fontSize: '15px',
        color: '#708090',
        fontStyle: "italic",
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px'
        }
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    blogLink: {
        textDecoration: "none",
        color: "inherit",
    },
});

class Blog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blogs: [],
            hasMore: true,
            limit: 9,
            loading: true
        }
    }

    componentDidMount() {
        this.fetchBlogs();
    }

    fetchBlogs = () => {
        axios.get('blog/fetch', {
            params: {
                offset: this.state.blogs.length,
                limit: this.state.limit
            }
        }).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    this.setState(prevState => ({
                        blogs: [...prevState.blogs, ...result.data.blogs]
                    }), () => {
                        this.setState({
                            loading: false
                        });
                        if (result.data.blogs.length === 0 || this.state.blogs.length < this.state.limit) {
                            this.setState({
                                hasMore: false
                            });
                        }
                    });
                } else {
                    openSnackbar({ message: result.data.msg, variant: "error" });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <Navbar />
                <Snackbar />
                <Hero image="blog.jpg">
                    <div className={classes.heroContent}>
                        <Typography variant="h1" className={classes.heroHeader}>Blog</Typography>
                    </div>
                </Hero>
                <section className={classes.container}>
                    <Typography variant="h3" className={classes.textHeading}>RECENT POSTS</Typography>
                    <Grid container spacing={32}>
                        {this.state.blogs.map(blog => {
                            return (
                                <Grid item xs={12} sm={4} className={classes.blogCard} key={blog.id}>
                                    <Link to={`/blogPage?id=${blog.id}`} className={classes.blogLink}>
                                        <img src={blog.imageUrl} alt={blog.title} className={classes.blogImage} />
                                        <Typography variant="h3" className={classes.blogTitle}>{blog.title}</Typography>
                                        <Typography variant="h4" className={classes.blogDate}>{blog.createdAt}</Typography>
                                    </Link>
                                </Grid>
                            )
                        })}
                    </Grid>
                    {this.state.loading ? (<CircularProgress className={classes.progress} color="secondary" />) : null}
                    <br />
                    {this.state.hasMore ? (<Button variant="outlined" color="secondary" className={classes.loadMore}
                        onClick={() => {
                            this.fetchBlogs();
                        }}>Load More</Button>) : null}
                </section>
            </Fragment>
        );
    }
}

Blog.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(style)(Blog);